import { db } from "../firebase";
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
  arrayUnion
} from "firebase/firestore";

export async function createHousehold(name, userId){

  const code = Math.random().toString(36).substring(2,8).toUpperCase();

  const ref = await addDoc(
    collection(db,"households"),
    {
      name,
      code,
      members:[userId],
      createdAt:new Date()
    }
  );

  return { id:ref.id, code };

}

export async function findHouseholdByCode(code){

  const q = query(
    collection(db,"households"),
    where("code","==",code)
  );

  const snap = await getDocs(q);

  if(snap.empty) return null;

  const docData = snap.docs[0];

  return {
    id:docData.id,
    ...docData.data()
  };

}

export async function joinHousehold(householdId, userId) {
  const ref = doc(db, "households", householdId);

  await updateDoc(ref, {
    members: arrayUnion(userId)
  });
}